// extracted by mini-css-extract-plugin
module.exports = {"headingContainer":"_4HkvLyhI","heading":"_FsGlRUK","breadcrumbs":"glmi0dAq","withBreadcrumbs":"_FD0PuvC"};